
import React, { useState, useEffect, useContext, useRef } from 'react';
import packageJson from '../package.json';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useUserAPI } from './components/useUserAPI';
import DeviceContext from './components/DeviceContext';
// import UAParser from 'ua-parser-js';
import { PolicyCheck } from './pages/home/PolicyCheck'
import { Home } from './pages/home/Home'
import { Intro } from './pages/intro/Intro'
import { Attention } from './pages/shopping/Attention'
import { Shopping } from './pages/shopping/Shopping'
import { Modal } from './components/Modal'
import { PayModal } from './components/PayModal'
import { NoBarcode } from './pages/shopping/NoBarcode'
import { ItemNum } from './pages/shopping/ItemNum'
import { ItemDelete } from './pages/shopping/ItemDelete'
import { GetAttention } from './pages/shopping/GetAttention'
import BarcodeScanner from './pages/scan/BarcodeScanner'
import QRScanner from './pages/scan/QRScanner'
import BarkoderScanner from './pages/scan/BarkoderScanner'
import QRBarkoderScanner from './pages/scan/QRBarkoderScanner'
import ScanbotScanner from './pages/scan/ScanbotScanner'
import QRScanbotScanner from './pages/scan/QRScanbotScanner'
// import { RegiSelect } from './pages/regi/RegiSelect'
import { FrontCheck } from './pages/regi/FrontCheck'
import { RegiSenyou } from './pages/regi/RegiSenyou'
import { RegiSenyouComp } from './pages/regi/RegiSenyouComp'
import { RegiSelf } from './pages/regi/RegiSelf'
import { RegiSelfComp } from './pages/regi/RegiSelfComp'
import { RegiYujin } from './pages/regi/RegiYujin'
import { RegiMeisai } from './pages/regi/RegiMeisai'
import { Faq } from './pages/other/Faq'
import { Policy } from './pages/other/Policy'
import { Help } from './pages/other/Help'
import { Setting } from './pages/other/Setting'
import { KujiLottery } from './pages/kuji/KujiLottery'
import { KujiList } from './pages/kuji/KujiList'
import { SharedInfoContext } from './components/SharedInfoContextProvider';
import { Error32 } from './components/Error32';
import { Error35 } from './components/Error35';
import { ErrorVersion } from './components/ErrorVersion';

import { GPSStorelist } from './components/GPSStorelist';
import { ShoppingStart } from './components/ShoppingStart';
// import { iAeonMiniApp } from './library/iaeon_sdk_240405';
// import * as IaeonSdk from './library/iaeon_sdk.js';
import { iAeonInit } from './library/iaeon_sdk.js';
import { iAeonGetMemberInfo } from './library/iaeon_sdk.js';
import { iAeonGetLocation } from './library/iaeon_sdk.js';
import { iAeonGetPointBarCode } from './library/iaeon_sdk.js';
import { iAeonGetAppInfo } from './library/iaeon_sdk.js';
import { iAeonGetData } from './library/iaeon_sdk.js';
import { iAeonSetData } from './library/iaeon_sdk.js';
import { iAeonCheckSilentMode } from './library/iaeon_sdk.js';
import { iAeonOpenBrowser } from './library/iaeon_sdk.js';
import { iAeonGetStoreInfo } from './library/iaeon_sdk.js';
import { useSDK } from "./scandit/sdk";
import { SCAN_SDK_SCANDIT, SCAN_SDK_BARKODER, SCAN_SDK_SCANBOT, getScanSdk, isScanSdkFixed } from './scanSdk/scanSdkSetting';
//※スキャンSDK名・解像度の表示（一時的に非表示。戻すときは import / state / 表示 の3箇所をまとめて有効化する
// import { getCameraResolution } from './scanSdk/cameraResolutionSetting';
import { startScanSdkCamera } from './scanSdk/scanSdkCamera';
import {AnimatePresence, motion} from 'framer-motion';

import styles from './styles/Home.module.scss'
import stylesB from './styles/BarcodeScanner.module.scss';

// import * as SDCCore from "scandit-web-datacapture-core";
// import { barcodeCaptureLoader } from "scandit-web-datacapture-barcode";

import useSound from 'use-sound';
import se_01 from './sound/s01_item_num.mp3';
import se_03 from './sound/s03_item_change.mp3';
import se_07_scan from './sound/s07_scan.mp3';
import se_08 from './sound/s08_se_delay0.mp3';
import se_10 from './sound/s10_item_delete.mp3';


const direction = {
	'policy_check': 'left',
	'home': 'left',
	'intro': 'left',
	'attention': 'left',
	'shopping': 'left',
	'scan': 'left',
	'qrscan': 'left',
	'regi_select': 'left',
	'front_check': 'left',
	'regi_senyou': 'left',
	'regi_senyou_comp': 'left',
	'regi_self': 'left',
	'regi_self_comp': 'left',
	'regi_yujin': 'left',
	'regi_meisai': 'left',
	'kuji_lottery': 'left',
	'kuji_list': 'left',
	'faq': 'left',
	'policy': 'left',
	'help': 'left',
	'setting': 'left',
	'error_32': 'left',
	'error_35': 'left',
	'error_version': 'left',
};
const motionConfig = {
	initial: {
		y: 30,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 30,
		opacity: 0,
	},
};

// let oldConponent = "home";
let oldConponent = "policy_check";
let moveDirection = "move_next";

function App() {
const { loaded, sdk } = useSDK();
const { startSDK } = useSDK();
	// const [key, setKey] = useState(0);

// useEffect(() => {
//     const handleVisibilityChange = (e) => {
// 		if (document.visibilityState === 'visible') {
// 			var userAgent = navigator.userAgent || navigator.vendor || window.opera;
// 			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { //iOS
// 				document.getElementById('fcover').classList.add('is_hide');
// 				alert("お買い物を再開します");
// 				// setErrFlg(true);
// 				// setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_CHECKIN]);
// 				// setErr([true,``,`;お買い物を再開;お買い物をつづけますか的な文言;;;`]);
// 				se08_stop();
// 				se08_se();
// 			}
// 		}
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     return () => {
// 		document.removeEventListener('visibilitychange', handleVisibilityChange);
//     };
// }, [se08_se,se08_stop]);

useEffect(() => {
	console.log(`RegigoApp: v${packageJson.version}`);
}, []);


//----------------------------------------
//ページ遷移
//----------------------------------------

// const navigate = useNavigate();
// const location = useLocation();
const nodeRef = useRef(null);
const [currentComponent, setCurrentComponent] = useState('');
// const [currentComponent, setCurrentComponent] = useState('home');
// const [currentComponent, setCurrentComponent] = useState('policy_check');
// const pathname = location.pathname;
const timeout = { enter: 300, exit: 300 };
// const getDirection = (currentKey: string) => direction[currentKey as keyof typeof direction] ?? 'left';
const getDirection = (currentKey) => direction[currentKey] ?? 'left';

const getMoveDir = () =>{
	if(oldConponent ==="error_version" && currentComponent !== "error_version"){
		moveDirection = "move_next";
	}else if(oldConponent ==="policy_check" && currentComponent !== "policy_check"){
		moveDirection = "move_next";
	}else if(oldConponent ==="home" && currentComponent !== "policy_check" && currentComponent !== "home"){
			moveDirection = "move_next";
	}else if(oldConponent ==="intro" && currentComponent !== "home" && currentComponent !== "intro"){
		moveDirection = "move_next";
	}else if(oldConponent ==="attention" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention"){
		moveDirection = "move_next";
	}else if(oldConponent ==="shopping" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping"){
		moveDirection = "move_next";
	}else if(oldConponent ==="scan" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "scan"){
		moveDirection = "move_next";
	}else if(oldConponent ==="qrscan" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_select" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select"){
		moveDirection = "move_next";
	}else if(oldConponent ==="front_check" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "front_check"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_senyou" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_senyou"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_senyou_comp" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_self" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_self_comp" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_yujin" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin"){
		moveDirection = "move_next";
	}else if(oldConponent ==="kuji_lottery" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_lottery"){
		moveDirection = "move_next";
	}else if(oldConponent ==="kuji_list" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_lottery" && currentComponent !== "kuji_list" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self_comp"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_meisai" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_lottery" && currentComponent !== "kuji_list" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_meisai"){
		moveDirection = "move_next";
	}else if(oldConponent ==="error_35" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "error_35"){
		moveDirection = "move_next";
	}else if(oldConponent ==="error_32" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "error_32"){
		moveDirection = "move_next";
	}else if(oldConponent ==="faq" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "faq"){
		moveDirection = "move_next";
	}else if(oldConponent ==="policy" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "policy"){
		moveDirection = "move_next";
	// }else if(oldConponent ==="help" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "help"){
	}else if(oldConponent ==="help" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "help"){
		moveDirection = "move_next";
	}else if(oldConponent ==="setting" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "setting"){
		moveDirection = "move_next";
	}else{
		moveDirection = "move_back";
	}
	// console.log("oldConponent: "+ oldConponent);
	// console.log("currentComponent: "+ currentComponent);
	// console.log("moveDirection: "+ moveDirection);
	// oldConponent = currentComponent;
	return moveDirection;
}

const setOldComponent = () => {
	oldConponent = currentComponent;
}

//----------------------------------------
// useState
//----------------------------------------

const { os, browser, device } = useContext(DeviceContext);

const [page, setPage] = useState("");
// const [page, setPage] = useState("home");
// const [page, setPage] = useState("policy_check");

// const [showModal, setShowModal] = useState(false)
// const [errNum, setErrNum] = useState("")
// const [errTxt, setErrTxt] = useState("")
// const [err, setErr] = useState([true,"ERR001","i1b0;お支払いコード読み取りエラー;お支払いコードの読み取りができませんでした。もう一度スキャンして頂くか、お近くの従業員にお声がけください。[34];Payment code reading error.;The payment code could not be read. Please scan the code again or call nearby staff for assistance.[34]"])
const [errFlg, setErrFlg] = useState(false)
const [err, setErr] = useState([])

const [delModal, setDelModal] = useState([])
const [showPayModal, setShowPayModal] = useState(false)
const [item, setItem] = useState(0)
const [gnav, setGnav] = useState(false)
const [showBarcodeScan, setBarcodeScan] = useState(false)
// const [scanFirst, setScanFirst] = useState(true);
// const [scanFirstStart, setScanFirstStart] = useState(false);
const [scanFlg, setScanFlg] = useState(false);
const [paycheckQR, setPaycheckQR] = useState()
const [shoppingStData, setShoppingStData] = useState()
const [kujiResult, setKujiResult] = useState([])
const [prizeList, setPrizeList] = useState()
const [keypluFlg, setKeypluFlg] = useState(false)
const [activeStore, setActiveStore] = useState()
const [closeStore, setCloseStore] = useState([])
//タイムアウト回数：-1はタイムアウトなし、0はカウント開始、3になったらエラー35
const [timeoutCountFlg, setTimeoutCountFlg] = useState(false)
const [timeoutCount, setTimeoutCount] = useState(0)
const [settlecheckFlg, setSettlecheckFlg] = useState(false)
const [keypluCount, setKeypluCount] = useState(0);
const [regiType, setRegiType] = useState();
const [recoveryChoice, setRecoveryChoice] = useState();
const [soundState, setSoundState] = useState()
const [scanActive, setScanActive] = useState("")
const [osinfo, setOsinfo] = useState()
const [appHeight, setAppHeight] = useState("")
const [home_realheight, setHome_realheight] = useState()
const [home_nHeight, setHome_nHeight] = useState()

//初回カメラ起動
const [cameraFirst, setCameraFirst] = useState(true);

//ボーナス、くじバナーアクティブ番号
const [activeBnSlide, setActiveBnSlide] = useState(0);

//SDK開始フラグ（true で startSDK（SDK開始
const [sdkStartFlg, setSdkStartFlg] = useState(false);
const [sdkStartFirst, setSdkStartFirst] = useState(true);

//利用するScanSDK（scandit / barkoder / scanbot
const [scanSdk, setScanSdk] = useState(() => getScanSdk());
//カメラ解像度（設定画面で切り替え。切替時はリロードされるため取り直される
//※スキャンSDK名・解像度の表示（一時的に非表示
// const [cameraResolution] = useState(() => getCameraResolution());

useEffect(() => {
	console.log("【ScanSDK】 " + scanSdk);
}, [scanSdk]);
//くじ・ボーナスアテンション
const [getAtState, setGetAtState] = useState([]);
//ボーナスアテンション用ボーナス金額
const [bonusAmount, setBonusAmount] = useState(0);
//くじアテンション用くじ回数
const [lotteryTimes, setLotteryTimes] = useState(0);
//くじ・ボーナスアテンション用 個数変更フラグ
const [getAtChange, setGetAtChange] = useState(false);
//せき止め再確認フラグ
const [frontCheckRetry, setFrontCheckRetry] = useState(false);
//URLパラメータ指定店舗（お気に入り店舗
const [ paramStore, setParamStore ] = useState();
//URLパラメータ指定店舗住所（お気に入り店舗住所
const [ paramStoreAddress, setParamStoreAddress ] = useState();
//近くの店舗住所
const [ storeAddressArr, setStoreAddressArr ] = useState([]);
//位置情報取得動作開始
const [posFlg, setPosFlg] = useState(false);
//OTB Code
const [otb, setOtb] = useState("");
// OTB取得中フラグ
const [isFetchingOtb, setIsFetchingOtb] = useState(false);
//OTB エラーフラグ（true:OTB取得失敗 false:通常 OTB取得成功
const [otbErr, setOtbErr] = useState(false);
//OTB エラーモーダル表示状態（true:OTBエラーモーダル表示済 false:OTBエラーモーダル未表示
const [otbErrDispState, setOtbErrDispState] = useState(false);

useEffect(() => {
	console.log("window.innerWidth: " + window.innerWidth);
	console.log("----------------------------");
	console.log("【page change】"+page);
	setCurrentComponent(page);
	console.log("oldConponent: "+ oldConponent);
	console.log("currentComponent: "+ currentComponent);
	setOldComponent();
	console.log("----------------------------");
}, [page]);

const { userinfoAPI, data: userData, loading: userLoading, error: userError } = useUserAPI();
const { userregisterAPI, data: userregisterData, loading: userregisterLoading, error: userregisterError } = useUserAPI();
//近く対象店舗リストAPI
const { gpsstorelistAPI, data: GPSStorelistData, loading: GPSStorelistLoading, error: GPSStorelistError } = useUserAPI();
//ミニアプリ用近くの店舗API
const { miniappgpsstorelistAPI, data: miniappgpsstorelistData, loading: miniappgpsstorelistLoading, error: miniappgpsstorelistError } = useUserAPI();
//店舗情報取得API（未使用 25.03.26
const { storelistAPI, data: storelistData, loading: storelistLoading, error: storelistError } = useUserAPI();
const [shoppingData, setShoppingData] = useState({});
const { getterminalnumberAPI, data: getterminalnumberData, loading: getterminalnumberLoading, error: getterminalnumberError } = useUserAPI();

//売上一覧：明細用
const [saleData, setSaleData] = useState({});

const sharedInfo = useContext(SharedInfoContext);
const { terminalCode, updateTerminalCode } = useContext(SharedInfoContext);
const { storeCode, updateStoreCode } = useContext(SharedInfoContext);
const { token, updateToken } = useContext(SharedInfoContext);
const { gateFlag, updateGateFlag } = useContext(SharedInfoContext);
const { storeInfo, updateStoreInfo } = useContext(SharedInfoContext);
const { lastTimeStoreCode, updateLastTimeStoreCode } = useContext(SharedInfoContext);
const { glocation, updategLocation } = useContext(SharedInfoContext);
const { favStore, updateFavStore } = useContext(SharedInfoContext);

const [shoppingArr, setShoppingArr] = useState([]);

//スタート画面高さ（一覧なし時に使用
const [homeHeight, setHomeHeight] = useState(800);

//----------------------------------------
// iAEON API：0.初期化API
//----------------------------------------

//0.初期化API
function callAPI_1(pastore){
	let successCall_0 = function(success){
		// alert("【iAeonInit】success");
	// console.log("callAPI_0 success："+success);
		// var aaa = JSON.stringify(success);
		var aaa = success;
		console.log('【iAeonInit】success：' + aaa);
		console.log('【iAeonInit】onetime_token：' + aaa.onetime_token);
		//19.データ取得API（ポリシー同意確認
		callAPI_19();
		//19.データ取得API（端末番号確認
		callAPI_19_tcode();
		//4.店舗情報取得API（住所取得
		if(pastore !== null){
			callAPI_4_paramStore(pastore);
		}
	}
	let errorCall_0 = function(error){
		// alert("【iAeonInit】error: " + error);
	// console.log("callAPI_0 error："+error);
		var bbb = error;
		console.log('【iAeonInit】error: ' + error.error_code + " : " + error.message);
		if(error.error_code === "000073"){ //「エラー73：既に初期化済み」の場合は、スルーして次へ
			//19.データ取得API（ポリシー同意確認
			callAPI_19();
			//19.データ取得API（端末番号確認
			callAPI_19_tcode();
		}else{
			setErrFlg(true);
			var error_msg = ";["+error.error_code+"];"+error.message+";;;";
			setErr([true, error.error_code, error_msg]);
		}
	}
	console.log("----------------------------");
	console.log("【iAeonInit】call");
	iAeonInit({"client_id":"55733068406029262116014198274077"}).then(successCall_0).catch(errorCall_0);
}


//----------------------------------------
// iAEON API：2.会員情報取得API
//----------------------------------------

//2.会員情報取得API
function callAPI_2(tcode){
    let successCall_2 = function(success){
		// alert("【iAeonGetMemberInfo】success");
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetMemberInfo】success：' + aaa);
		console.log('【iAeonGetMemberInfo】aeon_memberid：' + aaa.aeon_memberid);
		console.log('【iAeonGetMemberInfo】favorite_store：' + aaa.favorite_store);
		console.log('【iAeonGetMemberInfo】favorite_store[0].code：' + aaa.favorite_store[0].code);

		updateTerminalCode(tcode);
		//18.データ保存API（端末番号保存
		callAPI_18(tcode);
		//11.アプリケーション情報取得API
		callAPI_11(tcode);
    }
    let errorCall_2 = function(error){
		// alert("【iAeonGetMemberInfo】error: " + error);
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetMemberInfo】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log("【iAeonGetMemberInfo】call");
    iAeonGetMemberInfo().then(successCall_2).catch(errorCall_2);
}


//----------------------------------------
// iAEON API：11.アプリケーション情報取得API
//----------------------------------------

const { appInfo, updateAppInfo } = useContext(SharedInfoContext);
const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);
const { memberCodeVerCheck, updateMemberCodeVerCheck } = useContext(SharedInfoContext);

//11.アプリケーション情報取得API
function callAPI_11(tcode){
    let successCall_11 = function(success){
		// alert("【iAeonGetAppInfo】success");
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetAppInfo】success：' + aaa);
		console.log('【iAeonGetAppInfo】app_version：' + aaa.app_version);
		console.log('【iAeonGetAppInfo】app_version miin：' + process.env.REACT_APP_iAEON_VER);
		console.log('【iAeonGetAppInfo】os：' + aaa.os);
		console.log('【iAeonGetAppInfo】os_version：' + aaa.os_version);
		console.log('【iAeonGetAppInfo】os_version min：' + process.env.REACT_APP_iOS_VER);

		if (compareVersions(String(aaa.app_version), "5.1.0") < 0) {
			console.log("【iAeonGetAppInfo】AEON Pay連携確認: 5.1.0より小さい AEON Pay暫定版");
			updateAeonPayVerCheck(false);
		}else {
			console.log("【iAeonGetAppInfo】AEON Pay連携確認: 5.1.0以上 AEON Pay連携版");
			updateAeonPayVerCheck(true);
		}

		if (compareVersions(String(aaa.app_version), "5.4.0") < 0) {
			console.log("【iAeonGetAppInfo】会員コード連携確認: 5.4.0より小さい 会員コード暫定版（STEP1");
			updateMemberCodeVerCheck(false);
		}else {
			console.log("【iAeonGetAppInfo】会員コード連携確認: 5.4.0以上 会員コード連携版（STEP2");
			updateMemberCodeVerCheck(true);
		}

		let appVer = String(process.env.REACT_APP_iAEON_VER);
		if (compareVersions(String(aaa.app_version), appVer) < 0) {
			// console.log("bbbはaaaより大きい");
			console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");
			// alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");

			// if (loaded) {
			// 	sdk.cleanup();
			// }
			updateAppInfo(["iaeon_err",aaa.os]);
			console.log("【iAeonGetAppInfo】iAEON バージョンエラー → エラー画面へ");
			setCurrentComponent("error_version");
			setPage("error_version");
		} else {
			// console.log("aaaとbbbは同じバージョン");
			console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");
			// alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");

			if(aaa.os === "ios"){
				// console.log("【iAeonGetAppInfo】os check: ios "+aaa.os_version.substr(".")[0]);
				let iosVer = String(process.env.REACT_APP_iOS_VER);
				// if(aaa.os_version.substr(".")[0] < iosVer){
				if (compareVersions(String(aaa.os_version), iosVer) < 0) {
					console.log("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "より小さい");
					// alert("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "より小さい");

					// if (loaded) {
					// 	sdk.cleanup();
					// }
					updateAppInfo(["ios_err",aaa.os]);
					console.log("【iAeonGetAppInfo】iOS バージョンエラー → エラー画面へ");
					setCurrentComponent("error_version");
					setPage("error_version");
				}else{
					console.log("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "以上");
					// alert("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "以上");

					//12.位置情報取得API
					//callAPI_12(tcode);

					//userinfoAPI(tcode);

					//scandit SDK 開始
					// if(sdkStartFlg === false){
					// 	setSdkStartFlg(true);
					// }

					//24.サイレントモードチェックAPI：テスト
					// callAPI_24();

					//25.外部ブラウザOpenAPI：テスト
					// callAPI_25('https://www.aeonretail.jp/privacy/');
				}
			}else{
				console.log("【iAeonGetAppInfo】os check: ios以外");

				//12.位置情報取得API
				//callAPI_12(tcode);

				//userinfoAPI(tcode);

				//scandit SDK 開始
				// if(sdkStartFlg === false){
				// 	setSdkStartFlg(true);
				// }
				//24.サイレントモードチェックAPI：テスト
				// callAPI_24();

				//25.外部ブラウザOpenAPI：テスト
				// callAPI_25('https://www.aeonretail.jp/privacy/');
			}
		}
		// if(aaa.app_version < appVer){
		// 	console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");
		// 	alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");
		// }else{
		// 	console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");
		// 	alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");
		// }
    }
    let errorCall_11 = function(error){
		// alert("【iAeonGetAppInfo】error: " + error);
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetAppInfo】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonGetAppInfo】call');
    iAeonGetAppInfo().then(successCall_11).catch(errorCall_11);
}

//OSバージョン比較
function compareVersions(v1, v2) {
	const v1Parts = v1.split('.').map(Number);
	const v2Parts = v2.split('.').map(Number);

	for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
		const v1Part = v1Parts[i] || 0;
		const v2Part = v2Parts[i] || 0;

		if (v1Part > v2Part) {
			return 1;
		}
		if (v1Part < v2Part) {
			return -1;
		}
	}

	return 0;
}


//----------------------------------------
// iAEON API：12.位置情報取得API
//----------------------------------------

useEffect(() => {
	if(posFlg === true){
		//12.位置情報取得API
		callAPI_12(sharedInfo.terminalCode);
	}
}, [posFlg]);

//12.位置情報取得API
function callAPI_12(tcode){
	//仮対応
	// let pos = "35.600458, 140.113616";
	// updategLocation(pos);
	// console.log("sharedInfo.terminalCode: " + tcode);
	// userinfoAPI(tcode);

	//本対応
    let successCall_12 = function(success){
		// alert("【iAeonGetLocation】success");
        var aaa = success;
		console.log('【iAeonGetLocation】success：' + aaa);
		console.log('【iAeonGetLocation】latitude：' + aaa.latitude);
		console.log('【iAeonGetLocation】longitude：' + aaa.longitude);
		let pos = aaa.latitude + ", " + aaa.longitude;
		updategLocation(pos);
		console.log("sharedInfo.terminalCode: " + tcode);
		userinfoAPI(tcode);


		//25.外部ブラウザOpenAPI：テスト
		// callAPI_25('https://www.aeonretail.jp/privacy/');

		//11.アプリケーション情報取得API
		// callAPI_11();
		//scandit SDK 開始
		if(sdkStartFlg === false){
			setSdkStartFlg(true);
		}
    }
    let errorCall_12 = function(error){
		// alert("【iAeonGetLocation】error: " + error);
		var bbb = error;
		console.log('【iAeonGetLocation】error: ' + error.error_code + " : " + error.message);

		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});

		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonGetLocation】call');
    iAeonGetLocation().then(successCall_12).catch(errorCall_12);
}


//----------------------------------------
// iAEON API：24.サイレントモードチェックAPI
//----------------------------------------

//24.サイレントモードチェックAPI
function callAPI_24(){
    let successCall_24 = function(success){
		// alert("【iAeonCheckSilentMode】success");
        var aaa = success;
		console.log('【iAeonCheckSilentMode】success：' + aaa);
		console.log('【iAeonCheckSilentMode】is_silent_mode：' + aaa.is_silent_mode);
		// return aaa.is_silent_mode;

		console.log("soundState: ");
		console.log(soundState);

		if(soundState === "se01_item_num"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se01_item_num();
			}
			setSoundState();
		}else if(soundState === "se03_item_change"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se03_item_change();
			}
			setSoundState();
		}else if(soundState === "se10_delete"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se10_delete();
			}
			setSoundState();
		}else if(soundState === "se07_scan"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se07_scan();
			}
			setSoundState();
		}else if(soundState === "se08_se"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se08_se();
			}
			setSoundState();
		}
    }
    let errorCall_24 = function(error){
		// alert("【iAeonCheckSilentMode】error: " + error);
		var bbb = error;
		console.log('【iAeonCheckSilentMode】error: ' + error.error_code + " : " + error.message);
		// setErrFlg(true);
		// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		// setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonCheckSilentMode】call');
    iAeonCheckSilentMode().then(successCall_24).catch(errorCall_24);
}


//----------------------------------------
// iAEON API：25.外部ブラウザOpenAPI
//----------------------------------------

//25.外部ブラウザOpenAPI
function callAPI_25(surl){
    let successCall_25 = function(success){
		// alert("【iAeonOpenBrowser】success");
        var aaa = success;
		console.log('【iAeonOpenBrowser】success：' + aaa);

    }
    let errorCall_25 = function(error){
		// alert("【iAeonOpenBrowser】error: " + error);
		var bbb = error;
		console.log('【iAeonOpenBrowser】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonOpenBrowser】call');
    iAeonOpenBrowser({"url":surl}).then(successCall_25).catch(errorCall_25);
}

//4.店舗情報取得API（住所取得
function callAPI_4_paramStore(scode){
	console.log("----------------------------");
	console.log("【iAeonGetStoreInfo】post");
    let successCall_4 = function(success){
		var aaa = success;
		console.log('【iAeonGetStoreInfo】success：' + aaa);
		console.log('【iAeonGetStoreInfo】id：' + aaa.id);
		console.log('【iAeonGetStoreInfo】code：' + aaa.code);
		console.log('【iAeonGetStoreInfo】name：' + aaa.name);
		console.log('【iAeonGetStoreInfo】prefecture：' + aaa.prefecture);
		console.log('【iAeonGetStoreInfo】city：' + aaa.city);
		console.log('【iAeonGetStoreInfo】street：' + aaa.street);

		let saddress = aaa.prefecture + aaa.city + aaa.street;
		setParamStoreAddress(saddress);
		// storelistData.data.storeList[snum].storeAddress = saddress;
		// console.log('【iAeonGetStoreInfo】storelistData.data.storeList['+snum+'].storeAddress：' + storelistData.data.storeList[snum].storeAddress);
		// if(slast === true){ //最後
		// 	setStorelistAddress(true);

		// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		// 		element.classList.remove('is_show');
		// 	});
		// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		// 		element.classList.remove('is_show');
		// 	});
		// }

		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
    }
    let errorCall_4 = function(error){
		var bbb = error;
		console.log('【iAeonGetStoreInfo】error：' + bbb.error_code);

		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
    }

	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		element.classList.add('is_show');
	});
	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		element.classList.add('is_show');
	});

    iAeonGetStoreInfo({"store_code":scode}).then(successCall_4).catch(errorCall_4);
}


//----------------------------------------
// iAEON API：9.WAON POINTバーコード取得API（動作テスト
//----------------------------------------

//9.WAON POINTバーコード取得API（動作テスト
function callAPI_9(){
    let successCall_9 = function(success){
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetPointBarCode】success：' + aaa);
		console.log('【iAeonGetPointBarCode】code：' + aaa.code);
    }
    let errorCall_9 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetPointBarCode】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonGetPointBarCode】call');
    iAeonGetPointBarCode().then(successCall_9).catch(errorCall_9);
}

//17.決済用バーコード取得API（決済API、決済予約APIで使用
// function callAPI_17(){
//     let successCall_17 = function(success){
//         // var aaa = JSON.stringify(success);
//         var aaa = success;
// 		console.log('【iAeonGetPayBarCode】success：' + aaa);
// 		console.log('【iAeonGetPayBarCode】code：' + aaa.code);
// 		updateOtbCode(aaa.code);
//     }
//     let errorCall_17 = function(error){
//         // var bbb = JSON.stringify(error);
// 		var bbb = error;
// 		console.log('【iAeonGetPayBarCode】error: ' + error.error_code + " : " + error.message);
// 		// setErrFlg(true);
// 		// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
// 		// setErr([true, error.error_code, error_msg]);
//     }
	// console.log("----------------------------");
	// console.log('【iAeonGetPayBarCode】call');
//     iAeonGetPayBarCode().then(successCall_17).catch(errorCall_17);
// }


//----------------------------------------
// iAEON API：19.データ取得API（ポリシー同意確認
//----------------------------------------

//19.データ取得API（ポリシー同意確認
function callAPI_19(){
    let successCall_19 = function(success){
        var aaa = JSON.stringify(success);
		// var jsonString = success.replace(/”}$/, '"}}');
		// var aaa = JSON.perse(jsonString);
		console.log('【iAeonGetData:policy_data】success：' + aaa);
        var bbb = JSON.parse(aaa);
		console.log('【iAeonGetData:policy_data】bbb：');
		console.log(bbb);
        var ccc = JSON.parse(bbb.value);
		console.log('【iAeonGetData:policy_data】value：' + ccc);
		console.log(ccc);
		if(ccc === "true" || ccc === true){
			console.log("【iAeonGetData:policy_data】ポリシー同意あり → ホーム同意画面へ");
			setCurrentComponent("home");
			setPage("home");
		}else{
			console.log("【iAeonGetData:policy_data】ポリシー同意なし → ポリシー同意画面へ");
			setCurrentComponent("policy_check");
			setPage("policy_check");
		}
    }
    let errorCall_19 = function(error){
        // var bbb = JSON.stringify(error);
		// var bbb = error;
		console.log('【iAeonGetData:policy_data】error：: ' + error.error_code + " : " + error.message);
		console.log("【iAeonGetData:policy_data】ポリシー同意なし → ポリシー同意画面へ");

		setCurrentComponent("policy_check");
		setPage("policy_check");
    }
	console.log("----------------------------");
	console.log("【iAeonGetData】call");
    iAeonGetData({"key": "policy_data"}).then(successCall_19).catch(errorCall_19);
}


//----------------------------------------
// iAEON API：19.データ取得API（端末番号確認
//----------------------------------------

//19.データ取得API（端末番号確認
function callAPI_19_tcode(){
    let successCall_19 = function(success){
        var aaat = JSON.stringify(success);
		// var jsonString = success.replace(/”}$/, '"}}');
		// var aaa = JSON.perse(jsonString);
		console.log('【iAeonGetData:tcode】success：' + aaat);
        var bbbt = JSON.parse(aaat);
		console.log('【iAeonGetData:tcode】bbb：');
		console.log(bbbt);
        // var ccct = JSON.parse(bbbt.value);
        var ccct = bbbt.value;
		console.log('【iAeonGetData:tcode】value：' + ccct);
		console.log(ccct);
		console.log("【iAeonGetData:tcode】端末番号保存あり → 会員情報取得APIへ");
		//2.会員情報取得API
		// callAPI_2(ccct);

		updateTerminalCode(ccct);
		//18.データ保存API（端末番号保存
		callAPI_18(ccct);
		//11.アプリケーション情報取得API
		callAPI_11(ccct);
    }
    let errorCall_19 = function(error){
        // var bbb = JSON.stringify(error);
		// var bbb = error;
		console.log('【iAeonGetData:tcode】error：: ' + error.error_code + " : " + error.message);
		console.log("【iAeonGetData:tcode】端末番号保存なし → 端末番号取得へ");
		//端末番号発行API
		getterminalnumberAPI();
    }
	console.log("----------------------------");
	console.log("【iAeonGetData】call");
    iAeonGetData({"key": "tcode"}).then(successCall_19).catch(errorCall_19);
}


//----------------------------------------
// iAEON API：18.データ保存API（端末番号保存
//----------------------------------------

//18.データ保存API（端末番号保存
function callAPI_18(tcode){
	console.log("----------------------------");
	console.log("【iAeonSetData:tcode】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData:tcode】success：' + aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData:tcode】error：' + bbb.error_code);
		if(bbb.error_code === "000068"){
			iAeonSetData({"mode":"put", "key": "tcode", "value": tcode}).then(successCall_18).catch(errorCall_18);
		}
    }
    iAeonSetData({"mode":"add", "key": "tcode", "value": tcode}).then(successCall_18).catch(errorCall_18);
}


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	// 現在のURLを取得
	var url = new URL(window.location.href);
	console.log("url: " + window.location.href);

	if (!url.searchParams.has('time')) { //URLパラメータ：timeなし
		// 現在のタイムスタンプを取得
		var timestamp = Date.now();

		const domain = window.location.host;
		const queryString = String(window.location.href).split('?')[1] || '';
		// 新しいURLにリダイレクト
		if(domain === "miniapp.irs-test.jp"){
			console.log("domain check: dev");
			// window.location.href = "https://navy:1030003@miniapp.irs-test.jp/?" + queryString + "&time=" + timestamp;
			window.location.href = "https://miniapp.irs-test.jp/?" + queryString + "&time=" + timestamp;
		}else{
			console.log("domain check: other");
			url.searchParams.set('time', timestamp);
			window.location.href = url.href;
		}
	}else{ //URLパラメータ：timeあり
		const spHeight = window.innerHeight;
		document.documentElement.style.setProperty("--vh", spHeight / 100 + "px");


		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const pStore = urlParams.get('store_code');
		// const pStore = window.location.search.split("?store_code=")[1];
		console.log("paramStore: "+pStore);
		setParamStore(pStore);


		console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
		if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
			console.log("iAEON 有効");
			//0.初期化API
			callAPI_1(pStore);
		}else{ //iAEON無効

			console.log("iAEON 無効");
			const timestamp = Date.now();
			const tccode = "test" + timestamp;
			// const tccode = "testtesttest";
			updateTerminalCode(tccode);
			userinfoAPI(tccode);
			//scandit SDK 開始
			if(sdkStartFlg === false){
				setSdkStartFlg(true);
			}
			//ポリシー同意確認用
			// setCurrentComponent("policy_check");
			// setPage("policy_check");

			setCurrentComponent("home");
			setPage("home");
		}
		// iOS判定
		const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
		if (ios) { // iOS
			if(window.innerWidth > 320){
				document.querySelector("[name=viewport]").setAttribute('content','width=device-width, user-scalable=no');
			}else{
				document.querySelector("[name=viewport]").setAttribute('content','width=390, user-scalable=no');
			}
		}else { // Android
			if(window.innerWidth >= 320){
				document.querySelector("[name=viewport]").setAttribute('content','width=device-width, user-scalable=no');
			}else{
				document.querySelector("[name=viewport]").setAttribute('content','width=320, user-scalable=no');
			}
		}

		const audioContext = new (window.AudioContext || window.webkitAudioContext)();

		document.addEventListener("visibilitychange", () => {
			console.log("document.visibilityState: ");
			console.log(document.visibilityState);
			console.log("audioContext.state: ");
			console.log(audioContext.state);
			if (document.visibilityState === "visible") {
				console.log("audioContext: resume()");
				audioContext.resume().then(() => {
					console.log("audioContext resumed on user interaction.");
					console.log("audioContext.state: ");
					console.log(audioContext.state);
				}).catch((e) => {
					console.error("Failed to resume the audio context on user interaction:", e);
					console.log("audioContext.state: ");
					console.log(audioContext.state);
				});
			}
		});
	}

}, []);

//scandit SDK（ScanSDKがscanditのときのみ起動
useEffect(() => {
	if(startSDK && scanSdk === SCAN_SDK_SCANDIT){
		if(sdkStartFlg === true && sdkStartFirst === true){
			console.log("startSDK");
			setSdkStartFirst(false);
			startSDK();
		}
	}
}, [sdk,startSDK,sdkStartFlg,scanSdk]);

//barkoder / scanbot カメラ起動
//scanditのstartSDKと同じタイミング（スタート画面）でSDKの読み込みとカメラ起動を済ませ、初回スキャンを早くする
const sdkCameraStartedRef = useRef(null);

useEffect(() => {
	if(scanSdk === SCAN_SDK_SCANDIT) return;
	if(sdkStartFlg !== true) return;
	//SDKごとに1回だけ（設定画面で切り替えた場合は切替後のSDKで再実行
	if(sdkCameraStartedRef.current === scanSdk) return;

	sdkCameraStartedRef.current = scanSdk;
	startScanSdkCamera(scanSdk);
}, [sdkStartFlg, scanSdk]);

// useEffect(() => {
// 	if(loaded){
// 		if(sdkStartFlg === true){
// 			(async () => {
// 				await sdk.enableCamera(true);
// 			})();
// 		}
// 	}
// }, [loaded,sdkStartFlg]);


//----------------------------------------
//ユーザー情報取得API：レスポンス
//----------------------------------------

useEffect(() => {
	if (userData) {
		if (userData.data) { //SUCCESS
			console.log(`【userinfoAPI】 userinfoFlag: ${userData.data.userinfoFlag}`);
			console.log(`【userinfoAPI】 lastTimeStoreCode: ${userData.data.lastTimeStoreCode}`);

			updateLastTimeStoreCode(userData.data.lastTimeStoreCode);

			if(`${userData.data.userinfoFlag}` === 1){
				let location = "";
				if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
					console.log("iAEON GPS有効");
					location = sharedInfo.glocation;

				}else{ //iAEON GPS無効
					//幕張ベイパーク 0000050570
					// location = "35.646513, 140.049143";
					//イオンスタイル幕張新都心フードストア 0000082900
					// location = "35.656429, 140.027035";
					//イオンスタイル千葉みなと 0000052160
					location = "35.600458, 140.113616";
					//イオン東雲店 0000031200
					// location = "35.648562, 139.802152";
					//イオン大日 0000072700
					// location = "34.749439, 135.580529";
				}

				//24.09.05
				miniappgpsstorelistAPI(location);

				if(paramStore !== null){
					let favlist = [];
					if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON 有効
						console.log("iAEON 有効");
						// favlist = sharedInfo.favStore;
						// favlist.unshift({"storeCode": sharedInfo.lastTimeStoreCode});
						favlist = [
							{"storeCode": paramStore}
						];

					}else{ //iAEON 無効
						favlist = [
							{"storeCode": paramStore}
							// {"storeCode": sharedInfo.lastTimeStoreCode},
							// {"storeCode": "0000082900"},
							// {"storeCode": "0000052160"},
							// {"storeCode": "0000050570"},
							// {"storeCode": "0000031200"},
							// {"storeCode": "0000072700"}
						];
					}
					//未使用 25.03.26
					// storelistAPI(location,favlist);
				}
			}else{
				userregisterAPI();
			}
		} else { //ERROR
			console.log('【userinfoAPI】 userinfoFlag: Data property is missing');
		}
	} else {
		console.log('【userinfoAPI】 userinfoFlag: No Data');
	}
	if(userError){
		console.log("userError");
		console.log(userError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(userLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [userData,userLoading,userError]);


//----------------------------------------
//ユーザー情報登録API：レスポンス
//----------------------------------------

useEffect(() => {
	if (userregisterData) {
		console.log(userregisterData);
		if (userregisterData.isSuccess === true) {
			let location = "";
			if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
				console.log("iAEON GPS有効");
				location = sharedInfo.glocation;

			}else{ //iAEON GPS無効
				//幕張ベイパーク 0000050570
				// location = "35.646513, 140.049143";
				//イオンスタイル幕張新都心フードストア 0000082900
				// location = "35.656429, 140.027035";
				//イオンスタイル千葉みなと 0000052160
				location = "35.600458, 140.113616";
				//イオン東雲店 0000031200
				// location = "35.648562, 139.802152";
				//イオン大日 0000072700
				// location = "34.749439, 135.580529";
			}

			//24.09.05
			miniappgpsstorelistAPI(location);

			if(paramStore !== null){
				let favlist = [];
				if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON 有効
					console.log("iAEON 有効");
					// favlist = sharedInfo.favStore;
					// favlist.unshift({"storeCode": sharedInfo.lastTimeStoreCode});
					favlist = [
						{"storeCode": paramStore}
					];

				}else{ //iAEON 無効
					favlist = [
						{"storeCode": paramStore}
						// {"storeCode": sharedInfo.lastTimeStoreCode},
						// {"storeCode": "0000082900"},
						// {"storeCode": "0000052160"},
						// {"storeCode": "0000050570"},
						// {"storeCode": "0000031200"},
						// {"storeCode": "0000072700"}
					];
				}
				//未使用 25.03.26
				// storelistAPI(location,favlist);
			}
		}
	} else {
		console.log('【registerAPI】 userinfoFlag: No Data');
	}
	if(userregisterError){
		console.log("registerError");
		console.log(userregisterError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(userregisterLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [userregisterData,userregisterLoading,userregisterError]);


//----------------------------------------
//近く対象店舗リストAPI：レスポンス
//----------------------------------------

useEffect(() => {
	if(GPSStorelistData){
		if (GPSStorelistData.data) { //SUCCESS
			// console.log(`【GPSStorelistAPI】 storeList[0].storeCode: ${GPSStorelistData.data.storeList[0].storeCode}`);
			// console.log(`【GPSStorelistAPI】 storeList[0].storeName: ${GPSStorelistData.data.storeList[0].storeName}`);
			// console.log(`【GPSStorelistAPI】 storeList[0].gateFlag: ${GPSStorelistData.data.storeList[0].gateFlag}`);
			// const sstore = GPSStorelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(GPSStorelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = GPSStorelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

		}else{ //ERROR
			console.log(`【GPSStorelistAPI】 errorCode: ${GPSStorelistData.errorCode}`);
			console.log(`【GPSStorelistAPI】 errorMessage: ${GPSStorelistData.errorMessage}`);
			console.log(`【GPSStorelistAPI】 isSuccess: ${GPSStorelistData.isSuccess}`);

			// setErrNum(`${GPSStorelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${GPSStorelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${GPSStorelistData.errorCode}`,`${GPSStorelistData.errorMessage}`]);
		}
	}
	if(GPSStorelistError){
		console.log("GPSStorelistError");
		console.log(GPSStorelistError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(GPSStorelistLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [GPSStorelistData,GPSStorelistLoading,GPSStorelistError]);


//----------------------------------------
//ミニアプリ用近くの店舗API：レスポンス
//----------------------------------------

useEffect(() => { //未使用：24.09.05 → 使用：25.03.28
	if(miniappgpsstorelistData){
		if (miniappgpsstorelistData.data) { //SUCCESS
			// console.log(`【miniappgpsstorelistAPI】 storeList[0].storeCode: ${miniappgpsstorelistData.data.storeList[0].storeCode}`);
			// console.log(`【miniappgpsstorelistAPI】 storeList[0].storeName: ${miniappgpsstorelistData.data.storeList[0].storeName}`);
			// console.log(`【miniappgpsstorelistAPI】 storeList[0].gateFlag: ${miniappgpsstorelistData.data.storeList[0].gateFlag}`);
			// const sstore = miniappgpsstorelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(GPSStorelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = miniappgpsstorelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

			if(miniappgpsstorelistData.data.storeList.length > 0){
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeCode: ${miniappgpsstorelistData.data.storeList[0].storeCode}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeName: ${miniappgpsstorelistData.data.storeList[0].storeName}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeAddress: ${miniappgpsstorelistData.data.storeList[0].storeAddress}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].distance: ${miniappgpsstorelistData.data.storeList[0].distance}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].gateFlag: ${miniappgpsstorelistData.data.storeList[0].gateFlag}`);

				if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
					if(miniappgpsstorelistData.data.storeList.length !== 0){
						callAPI_4_miniappgpsstorelist(0,miniappgpsstorelistData.data.storeList[0].storeCode);
					}
				}
			}

		}else{ //ERROR
			console.log(`【miniappgpsstorelistAPI】 errorCode: ${miniappgpsstorelistData.errorCode}`);
			console.log(`【miniappgpsstorelistAPI】 errorMessage: ${miniappgpsstorelistData.errorMessage}`);
			console.log(`【miniappgpsstorelistAPI】 isSuccess: ${miniappgpsstorelistData.isSuccess}`);

			// setErrNum(`${miniappgpsstorelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${miniappgpsstorelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${miniappgpsstorelistData.errorCode}`,`${miniappgpsstorelistData.errorMessage}`]);
		}
	}
	if(miniappgpsstorelistError){
		console.log("miniappgpsstorelistError");
		console.log(miniappgpsstorelistError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(miniappgpsstorelistLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [miniappgpsstorelistData,miniappgpsstorelistLoading,miniappgpsstorelistError]);

const [storelistCount, setStorelistCount] = useState(0);

//4.店舗情報取得API（住所取得用 未使用：24.09.05 → 使用：25.03.28
function callAPI_4_miniappgpsstorelist(snum,scode){
	console.log("----------------------------");
	console.log("【iAeonGetStoreInfo_mini】post");
    let successCall_4 = function(success){
		var aaa = success;
		console.log('【iAeonGetStoreInfo_mini】success：' + aaa);
		console.log('【iAeonGetStoreInfo_mini】id：' + aaa.id);
		console.log('【iAeonGetStoreInfo_mini】code：' + aaa.code);
		console.log('【iAeonGetStoreInfo_mini】name：' + aaa.name);
		console.log('【iAeonGetStoreInfo_mini】prefecture：' + aaa.prefecture);
		console.log('【iAeonGetStoreInfo_mini】city：' + aaa.city);
		console.log('【iAeonGetStoreInfo_mini】street：' + aaa.street);

		let saddress = aaa.prefecture + aaa.city + aaa.street;
		miniappgpsstorelistData.data.storeList[snum].storeAddress = saddress;

		console.log('【iAeonGetStoreInfo_mini】newStoreAddressArr['+snum+']：' + saddress);
		setStorelistCount(snum);
		var nnum = snum + 1;
		if(nnum < miniappgpsstorelistData.data.storeList.length){
			callAPI_4_miniappgpsstorelist(nnum,miniappgpsstorelistData.data.storeList[nnum].storeCode);
		}
    }
    let errorCall_4 = function(error){
		var bbb = error;
		console.log('【iAeonGetStoreInfo_mini】error：' + bbb.error_code);

		miniappgpsstorelistData.data.storeList[snum].storeAddress = null;
		// miniappgpsstorelistData.data.storeList[snum].storeAddress = "ダミーテキストダミーテキスト";
		setStorelistCount(snum);
		var nnum = snum + 1;
		if(nnum < miniappgpsstorelistData.data.storeList.length){
			callAPI_4_miniappgpsstorelist(nnum,miniappgpsstorelistData.data.storeList[nnum].storeCode);
		}
    }
    iAeonGetStoreInfo({"store_code":scode}).then(successCall_4).catch(errorCall_4);
}


//----------------------------------------
//店舗情報取得API：レスポンス（未使用 25.03.26
//----------------------------------------

useEffect(() => {
	if(storelistData){
		if (storelistData.data) { //SUCCESS
			// console.log(`【storelistAPI】 storeList[0].storeCode: ${storelistData.data.storeList[0].storeCode}`);
			// console.log(`【storelistAPI】 storeList[0].storeName: ${storelistData.data.storeList[0].storeName}`);
			// console.log(`【storelistAPI】 storeList[0].gateFlag: ${storelistData.data.storeList[0].gateFlag}`);
			// const sstore = storelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(storelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = storelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

		}else{ //ERROR
			console.log(`【storelistAPI】 errorCode: ${storelistData.errorCode}`);
			console.log(`【storelistAPI】 errorMessage: ${storelistData.errorMessage}`);
			console.log(`【storelistAPI】 isSuccess: ${storelistData.isSuccess}`);

			// setErrNum(`${storelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${storelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${storelistData.errorCode}`,`${storelistData.errorMessage}`]);
		}
	}
	if(storelistError){
		console.log("storelistError");
		console.log(storelistError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(storelistLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		// if(page !== "home"){
			document.querySelectorAll('.loadingBox01').forEach(function(element) {
				element.classList.remove('is_show');
			});
			document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
				element.classList.remove('is_show');
			});
		// }
	}
}, [storelistData,storelistLoading,storelistError]);


//----------------------------------------
//端末番号発行API：レスポンス
//----------------------------------------

useEffect(() => {
	if(getterminalnumberData){
		if (getterminalnumberData.data) { //SUCCESS
			console.log(`【getterminalnumberAPI】 terminalCode: ${getterminalnumberData.data.terminalCode}`);

			//2.会員情報取得API
			// callAPI_2(getterminalnumberData.data.terminalCode);

			updateTerminalCode(getterminalnumberData.data.terminalCode);
			//18.データ保存API（端末番号保存
			callAPI_18(getterminalnumberData.data.terminalCode);
			//11.アプリケーション情報取得API
			callAPI_11(getterminalnumberData.data.terminalCode);

		}else{ //ERROR
			console.log(`【getterminalnumberAPI】 errorCode: ${getterminalnumberData.errorCode}`);
			console.log(`【getterminalnumberAPI】 errorMessage: ${getterminalnumberData.errorMessage}`);
			console.log(`【getterminalnumberAPI】 isSuccess: ${getterminalnumberData.isSuccess}`);

			// setErrNum(`${storelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${storelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${getterminalnumberData.errorCode}`,`${getterminalnumberData.errorMessage}`]);
		}
	}
	if(getterminalnumberError){
		console.log("getterminalnumberError");
		console.log(getterminalnumberError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(getterminalnumberLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [getterminalnumberData,getterminalnumberLoading,getterminalnumberError]);


//----------------------------------------
//
//----------------------------------------

const [barcode, setBarcode] = useState('');
// const [intervalFlg, setIntervalFlg] = useState(null);

const [showNoBarcode, setShowNoBarcode] = useState(false)

const onNoBarcode = () => {
	setShowNoBarcode(true)
}

const [showItemNum, setShowItemNum] = useState([])

const onItemNum = () => {
	setShowItemNum(true)
}


//----------------------------------------
// お買い物を中止する
//----------------------------------------

const closeApp = () => {
	console.log("page: " + page);
	setErrFlg(true);
	if(shoppingData && shoppingData.data && shoppingData.data.sumItemCount !== 0){
		if(page === "regi_senyou_comp" || page === "regi_self_comp" || page === "regi_yujin" || page === "regi_meisai"){ //支払完了
			console.log("支払完了");
			setErrFlg(true);
			setErr([true,`shopping_cancel03`,`;;;;;`]);
		}else{ //買物データあり
			console.log("買物データあり");
			console.log("shoppingData.data.sumItemCount: " + shoppingData.data.sumItemCount);
			setErrFlg(true);
			setErr([true,`shopping_cancel02`,`;;;;;`]);
		}
	}else{ //買物データなし、買物0件
		if(page === "home" || page === "intro" || page === "regi_senyou_comp" || page === "regi_self_comp" || page === "regi_yujin" || page === "regi_meisai" || page === "policy_check"){
			console.log("買物開始前");
			console.log("shoppingData.data :" + "nodata");
			setErrFlg(true);
			setErr([true,`shopping_cancel03`,`;;;;;`]);
		}else{
			console.log("買物データなし、買物0件");
			console.log("shoppingData.data :" + "0");
			setErrFlg(true);
			setErr([true,`shopping_cancel`,`;;;;;`]);
		}
	}
	// se08_se();
	setSoundState("se08_se");
}


//----------------------------------------
// ページコンポーネント
//----------------------------------------

const renderComponent = () => {
	switch (currentComponent) {
	case 'intro':
		return <Intro page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} shoppingData={shoppingData} setShoppingData={setShoppingData} soundState={soundState} setSoundState={setSoundState} paramStore={paramStore} paramStoreAddress={paramStoreAddress}/>
	case 'attention':
		return <Attention page={page} setPage={setPage} soundState={soundState} setSoundState={setSoundState}/>
	case 'shopping':
		return <Shopping page={page} setPage={setPage} item={item} setItem={setItem} showNoBarcode={showNoBarcode} setShowNoBarcode={setShowNoBarcode} showBarcodeScan={showBarcodeScan} setBarcodeScan={setBarcodeScan} showPayModal={showPayModal} setShowPayModal={setShowPayModal} showItemNum={showItemNum} setShowItemNum={setShowItemNum} delModal={delModal} setDelModal={setDelModal} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} keypluFlg={keypluFlg} soundState={soundState} setSoundState={setSoundState} scanActive={scanActive} setScanActive={setScanActive} shoppingArr={shoppingArr} setShoppingArr={setShoppingArr} appHeight={appHeight} setAppHeight={setAppHeight} cameraFirst={cameraFirst} setCameraFirst={setCameraFirst} activeBnSlide={activeBnSlide} setActiveBnSlide={setActiveBnSlide} sdkStartFlg={sdkStartFlg} setSdkStartFlg={setSdkStartFlg} getAtState={getAtState} setGetAtState={setGetAtState} bonusAmount={bonusAmount} setBonusAmount={setBonusAmount} lotteryTimes={lotteryTimes} setLotteryTimes={setLotteryTimes} getAtChange={getAtChange} setGetAtChange={setGetAtChange} otb={otb} setOtb={setOtb} otbErr={otbErr} setOtbErr={setOtbErr} isFetchingOtb={isFetchingOtb} setIsFetchingOtb={setIsFetchingOtb} isWaitingForOtb={isWaitingForOtb} setIsWaitingForOtb={setIsWaitingForOtb} isButtonDisabled={isButtonDisabled} setIsButtonDisabled={setIsButtonDisabled} isKaikeiButtonDisabled={isKaikeiButtonDisabled} setIsKaikeiButtonDisabled={setIsKaikeiButtonDisabled} isScanButtonDisabled={isScanButtonDisabled} setIsScanButtonDisabled={setIsScanButtonDisabled} scanResultFlg={scanResultFlg} setScanResultFlg={setScanResultFlg} osinfo={osinfo} setSaleData={setSaleData} scanSdk={scanSdk}/>
	case 'scan':
		//ScanSDK切替：商品スキャン
		if(scanSdk === SCAN_SDK_BARKODER){
			return <div>
			<BarkoderScanner page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} soundState={soundState} setSoundState={setSoundState}/>
			</div>
		}else if(scanSdk === SCAN_SDK_SCANBOT){
			return <div>
			<ScanbotScanner page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} soundState={soundState} setSoundState={setSoundState}/>
			</div>
		}
		return <div>
		<BarcodeScanner page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} soundState={soundState} setSoundState={setSoundState}/>
		</div>
	case 'qrscan':
		//ScanSDK切替：QRスキャン
		if(scanSdk === SCAN_SDK_BARKODER){
			return <div>
			<QRBarkoderScanner page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} setSaleData={setSaleData} appHeight={appHeight} setAppHeight={setAppHeight} otb={otb} setOtb={setOtb}/>
			</div>
		}else if(scanSdk === SCAN_SDK_SCANBOT){
			return <div>
			<QRScanbotScanner page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} setSaleData={setSaleData} appHeight={appHeight} setAppHeight={setAppHeight} otb={otb} setOtb={setOtb}/>
			</div>
		}
		return <div>
		<QRScanner page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} setSaleData={setSaleData} appHeight={appHeight} setAppHeight={setAppHeight} otb={otb} setOtb={setOtb}/>
		</div>
	case 'front_check':
		return <FrontCheck page={page} setPage={setPage} shoppingStData={shoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} frontCheckRetry={frontCheckRetry} setFrontCheckRetry={setFrontCheckRetry} appHeight={appHeight}/>
	case 'regi_senyou':
		return <RegiSenyou page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} setPaycheckQR={setPaycheckQR} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} settlecheckFlg={settlecheckFlg} setSettlecheckFlg={setSettlecheckFlg} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} appHeight={appHeight} otbErr={otbErr} setOtbErr={setOtbErr} otbErrDispState={otbErrDispState} setOtbErrDispState={setOtbErrDispState}/>
	case 'regi_senyou_comp':
		return <RegiSenyouComp page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight}/>
	case 'regi_self':
		return <RegiSelf page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} setPaycheckQR={setPaycheckQR} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} settlecheckFlg={settlecheckFlg} setSettlecheckFlg={setSettlecheckFlg} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} appHeight={appHeight} otbErr={otbErr} setOtbErr={setOtbErr} otbErrDispState={otbErrDispState} setOtbErrDispState={setOtbErrDispState}/>
	case 'regi_self_comp':
		return <RegiSelfComp page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight}/>
	case 'regi_yujin':
		return <RegiYujin page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight} otbErr={otbErr} setOtbErr={setOtbErr} otbErrDispState={otbErrDispState} setOtbErrDispState={setOtbErrDispState}/>
	case 'regi_meisai':
		return <RegiMeisai page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight} setAppHeight={setAppHeight} saleData={saleData}/>
	case 'error_32':
		return <Error32 page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'error_35':
		return <Error35 page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'error_version':
		return <ErrorVersion page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'faq':
		return <Faq page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'policy':
		return <Policy page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'help':
		return <Help page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'setting':
		return <Setting page={page} setPage={setPage} scanSdk={scanSdk} setScanSdk={setScanSdk} onPageBack={onPageBack} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>
	case 'kuji_lottery':
		return <KujiLottery page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} kujiResult={kujiResult} setKujiResult={setKujiResult} prizeList={prizeList} setPrizeList={setPrizeList} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState}/>
	case 'kuji_list':
		return <KujiList page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} kujiResult={kujiResult} setKujiResult={setKujiResult} prizeList={prizeList} setPrizeList={setPrizeList} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState}/>
	case 'home':
		return <Home page={page} setPage={setPage} GPSStorelistData={GPSStorelistData} miniappgpsstorelistData={miniappgpsstorelistData} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} shoppingData={shoppingData} setShoppingData={setShoppingData} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} storelistData={storelistData} userData={userData} osinfo={osinfo} setOsinfo={setOsinfo} home_realheight={home_realheight} setHome_realheight={setHome_realheight} home_nHeight={home_nHeight} setHome_nHeight={setHome_nHeight} soundState={soundState} setSoundState={setSoundState} paramStore={paramStore} paramStoreAddress={paramStoreAddress} storeAddressArr={storeAddressArr} setStoreAddressArr={setStoreAddressArr} storelistCount={storelistCount} sdkStartFlg={sdkStartFlg} setSdkStartFlg={setSdkStartFlg} posFlg={posFlg} setPosFlg={setPosFlg} homeHeight={homeHeight} setHomeHeight={setHomeHeight}/>
	case 'policy_check':
		return <PolicyCheck page={page} setPage={setPage} GPSStorelistData={GPSStorelistData} miniappgpsstorelistData={miniappgpsstorelistData} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} shoppingData={shoppingData} setShoppingData={setShoppingData} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} storelistData={storelistData} userData={userData} osinfo={osinfo} setOsinfo={setOsinfo} soundState={soundState} setSoundState={setSoundState}/>
	}
};


//----------------------------------------
// ページ遷移
//----------------------------------------

//FAQ
const goFaq = () => {
	setTimeout(function(){
		setPage("faq")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}
//ポリシー
const goPolicy = () => {
	setTimeout(function(){
		setPage("policy")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}

//ヘルプ
const goHelp = () => {
	setTimeout(function(){
		setPage("help")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}

//ScanSDK設定
const goSetting = () => {
	setTimeout(function(){
		setPage("setting")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}

//戻る
const onPageBack = () => {
	setPage(oldConponent)
	// se08_se();
	setSoundState("se08_se");
}
// const goMyTab = () => {
// 	setPage("mytab")
// }

//メニュー開く
const onMenuBtn = () => {
	// e.preventDefault();
	// setGnav(true)
	setGnav(current => !current);
	// document.html.classList.add('my-custom-class');
	if (gnav === true) {
		document.documentElement.classList.remove('is_fixed');
		document.body.classList.remove('is_fixed');
	}else{
		document.documentElement.classList.add('is_fixed');
		document.body.classList.add('is_fixed');
	}
	// se08_se();
	setSoundState("se08_se");
}

//くじ一覧：閉じる
const closeKujiList = () => {
	// props.setPage("regi_yujin")
	console.log("regiType: " + regiType);
	setPage(regiType);
	// se08_se();
	setSoundState("se08_se");
}


//----------------------------------------
//サウンド
//----------------------------------------

// const [se08_se] = useSound(se_08);
// let [se08_play, { stop: se08_stop }] = useSound(se_08, { key });

const [se07_scan] = useSound(se_07_scan);

const [isPlaying_s08, setIsPlaying_s08] = useState(false);
// const [se08_se, { stop: se08_stop }] = useSound(se_08, {
const [se08_se, se08_item_num_controls] = useSound(se_08, {
	interrupt: false,
    onplay: () => setIsPlaying_s08(true),
    onend: () => setIsPlaying_s08(false),
    onstop: () => setIsPlaying_s08(false),
});


//----------------------------------------
//サウンド有効・無効
//----------------------------------------

const [isPlaying_s01, setIsPlaying_s01] = useState(false);
const [isPlaying_s03, setIsPlaying_s03] = useState(false);
const [isPlaying_s10, setIsPlaying_s10] = useState(false);

const [se01_item_num,se01_item_num_controls] = useSound(se_01, {
	interrupt: true,
    onplay: () => setIsPlaying_s01(true),
    onend: () => setIsPlaying_s01(false),
    onstop: () => setIsPlaying_s01(false),
});
const [se03_item_change,se03_item_change_controls] = useSound(se_03, {
	interrupt: true,
    onplay: () => setIsPlaying_s03(true),
    onend: () => setIsPlaying_s03(false),
    onstop: () => setIsPlaying_s03(false),
});
const [se10_delete,se10_delete_controls] = useSound(se_10, {
	interrupt: true,
    onplay: () => setIsPlaying_s10(true),
    onend: () => setIsPlaying_s10(false),
    onstop: () => setIsPlaying_s10(false),
});

useEffect(() => {
	// if(soundState !== ""){
	// 	se01_item_num_controls.stop();
	// 	se03_item_change_controls.stop();
	// 	se10_delete_controls.stop();
	// }
	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//24.サイレントモードチェックAPI
		callAPI_24();

	}else{ //iAEON無効
		console.log("soundState: ");
		console.log(soundState);

		if(soundState === "se01_item_num"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se01_item_num();
			setSoundState();
		}else if(soundState === "se03_item_change"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se03_item_change();
			setSoundState();
		}else if(soundState === "se10_delete"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se10_delete();
			setSoundState();
		}else if(soundState === "se07_scan"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se07_scan();
			setSoundState();
		}else if(soundState === "se08_se"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se08_se();
			setSoundState();
		}
	}
}, [soundState]);


//----------------------------------------
//ボタン抑制
//----------------------------------------

//「スキャン」ボタン有効・無効 true：無効 false：有効
const [isScanButtonDisabled, setIsScanButtonDisabled] = useState(false);
//「お会計」ボタン有効・無効 true：無効 false：有効
const [isKaikeiButtonDisabled, setIsKaikeiButtonDisabled] = useState(false);
//「お支払いへ進む」ボタンがクリックされたか
const [isWaitingForOtb, setIsWaitingForOtb] = useState(false);
//「お支払いへ進む」ボタンの連打防止フラグ
const [isButtonDisabled, setIsButtonDisabled] = useState(false);


//----------------------------------------
//スキャン結果表示（zxing・MLkit用
//----------------------------------------

//スキャン結果表示フラグ
const [scanResultFlg, setScanResultFlg] = useState(false)

//スキャン結果表示用モーション
const scanResultMotionConfig = {
	initial: {
		y: -20,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 20,
		opacity: 0,
	},
};
//スキャン結果背景用モーション
const scanResultModalBox_cover = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 0.55,
	},
	hidden: {
		opacity: 0,
	},
};


return (
<>
<GPSStorelist.Provider value={GPSStorelistData}>
<ShoppingStart.Provider value={shoppingStData}>
{/* <ShoppingStart.Provider value={shoppingStartData}> */}
	<div className={`loadingBox01`}>
		<div className={`loadingBox01_img`}>
			<img src="/images/loading01.svg" alt="" width="55" height="55"/>
		</div>
	</div>
	<div className={`loadingBox01_cover`}></div>
	<div id="fcover" className={`first_cover`}></div>
	<header id="header" className="l_header">
		{
			(() => {
				if (page === "faq" || page === "policy" || page === "help" || page === "setting" || page === "regi_meisai") {
				return(
					<button className={`header_btn header_menuBtn is_open`} onClick={onPageBack}>
						<span><img src="/images/icn_back01_black.svg" alt="" width="24" height="24"/></span>
						<img src="/images/btn_menu01.svg" alt="" width="24" height="24"/>
					</button>
				)
				} else if (page === "kuji_list") {
				return(
					<button className={`header_btn header_menuBtn is_open`} onClick={closeKujiList}>
						<span><img src="/images/icn_back01_black.svg" alt="" width="24" height="24"/></span>
						<img src="/images/btn_menu01.svg" alt="" width="24" height="24"/>
					</button>
				)
				} else if (page === "policy_check") {
				return(
					<button className={`header_btn header_menuBtn is_hide`}></button>
				)
				} else {
				return (
					<button className={`header_btn header_menuBtn ${gnav ? 'is_open' : ''}`} onClick={onMenuBtn}>
						<span><img src="/images/icn_back01_black.svg" alt="" width="24" height="24"/></span>
						<img src="/images/btn_menu01.svg" alt="" width="24" height="24"/>
					</button>
				)
				}
			})()
		}
		{
			(() => {
				if (page === "home") {
				return(
					// <div className="header_logo is_hide">
					// 	<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24" loading="lazy"/></span>
					// </div>
					<div className="header_titBox">
						<div className="header_logo is_hide">
							<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
						</div>
						<p className="header_tit is_hide">よくあるご質問</p>
					</div>
				)
				} else if (page === "faq") {
				return(
					// <div className="header_logo is_hide">
					// 	<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24" loading="lazy"/></span>
					// </div>
					<div className="header_titBox">
						<div className="header_logo is_hide">
							<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
						</div>
						<p className="header_tit">よくあるご質問</p>
					</div>
				)
				} else if (page === "policy" || page === "policy_check") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">ご利用規約</p>
						</div>
					)
				} else if (page === "help") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">ご利用方法</p>
						</div>
					)
				} else if (page === "setting") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">設定</p>
						</div>
					)
				} else if (page === "kuji_list") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">くじ抽選結果</p>
						</div>
					)
				} else if (page === "regi_meisai") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">本日のお買い物</p>
						</div>
					)
				} else {
				return (
					// <div className="header_logo">
					// 	<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24" loading="lazy"/></span>
					// </div>
					<div className="header_titBox">
						<div className="header_logo is_hide">
							<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
						</div>
						<p className="header_tit is_hide">よくあるご質問</p>
					</div>
				)
				}
			})()
		}
		{
			(() => {
				if (page === "faq" || page === "policy" || page === "help" || page === "setting" || page === "kuji_list" || page === "regi_meisai") {
				return(
					<button className={`header_btn header_closeBtn is_hide`} onClick={closeApp}>
						<img src="/images/btn_close01.svg" alt="" width="24" height="24"/>
					</button>
				)
				} else {
				return (
					<button className={`header_btn header_closeBtn ${gnav ? 'is_hide' : ''}`} onClick={closeApp}>
						<img src="/images/btn_close01.svg" alt="" width="24" height="24"/>
					</button>
				)
				}
			})()
		}
	</header>
	{
		(() => {
			if (page === "policy_check" || page === "home" || page === "intro" || page === "attention" || page === "shopping" || page === "scan" || page === "qrscan" || page === "regi_select" || page === "front_check" || page === "regi_senyou" || page === "regi_senyou_comp" || page === "regi_self" || page === "regi_self_comp" || page === "regi_yujin" || page === "regi_meisai" || page === "faq" || page === "policy" || page === "help" || page === "setting" || page === "kuji_lottery" || page === "kuji_list" || page === "error_32" || page === "error_35" || page === "error_version") { //お気に入り店舗スタート画面/ウォークスルー/お買物ホーム
				return (
	<div id="contents" className="container l_contents">
		<TransitionGroup component="div" className="App">
		<CSSTransition
			nodeRef={nodeRef}
			key={currentComponent}
			timeout={timeout}
			classNames="slider"
		>
			<div ref={nodeRef} className={`${currentComponent} ${getDirection(currentComponent)} ${getMoveDir()}`}>
				{renderComponent()}
			</div>
		</CSSTransition>
		</TransitionGroup>
						</div>
					)
				}
			})()
		}

		<PayModal showPayModal={showPayModal} setShowPayModal={setShowPayModal} page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} scanActive={scanActive} setScanActive={setScanActive} soundState={soundState} setSoundState={setSoundState} otb={otb} setOtb={setOtb} otbErr={otbErr} setOtbErr={setOtbErr} isFetchingOtb={isFetchingOtb} setIsFetchingOtb={setIsFetchingOtb} isWaitingForOtb={isWaitingForOtb} setIsWaitingForOtb={setIsWaitingForOtb} isButtonDisabled={isButtonDisabled} setIsButtonDisabled={setIsButtonDisabled} isKaikeiButtonDisabled={isKaikeiButtonDisabled} setIsKaikeiButtonDisabled={setIsKaikeiButtonDisabled} isScanButtonDisabled={isScanButtonDisabled} setIsScanButtonDisabled={setIsScanButtonDisabled} osinfo={osinfo} setSaleData={setSaleData} setRegiType={setRegiType}/>

		<Modal page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} settlecheckFlg={settlecheckFlg} setSettlecheckFlg={setSettlecheckFlg} regiType={regiType} setRegiType={setRegiType} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} shoppingData={shoppingData} soundState={soundState} setSoundState={setSoundState} frontCheckRetry={frontCheckRetry} setFrontCheckRetry={setFrontCheckRetry}/>

		<ItemDelete delModal={delModal} setDelModal={setDelModal} page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState}/>

		<GetAttention delModal={delModal} setDelModal={setDelModal} page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} getAtState={getAtState} setGetAtState={setGetAtState} getAtChange={getAtChange} setGetAtChange={setGetAtChange} />

		<NoBarcode showNoBarcode={showNoBarcode} setShowNoBarcode={setShowNoBarcode} shoppingData={shoppingData} setShoppingData={setShoppingData} showItemNum={showItemNum} setShowItemNum={setShowItemNum} shoppingStData={shoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} keypluFlg={keypluFlg} setKeypluFlg={setKeypluFlg} keypluCount={keypluCount} setKeypluCount={setKeypluCount} setSoundState={setSoundState}/>

		<ItemNum showItemNum={showItemNum} setShowItemNum={setShowItemNum} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} getAtChange={getAtChange} setGetAtChange={setGetAtChange} />

		<nav id="globalNav" className={`${styles.l_globalNav} ${gnav ? styles.is_open : ''}`}>
			<div className={styles.l_globalNav_wrap}>
				<div className={styles.l_globalNav_in}>
					<div className={styles.l_globalNav_top}>
						<p className={styles.globalNav_txt}>レジゴーについて</p>
						<nav className={styles.globalNav}>
							<button onClick={goHelp} className={`${styles.globalNav_btn} custom_btn`}>
							<span className={styles.globalNav_btn_ar}>
								<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
							</span>
						ヘルプ</button>
							{/* <button onClick={goFaq} className={`${styles.globalNav_btn} custom_btn`}>
							<span className={styles.globalNav_btn_ar}>
								<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
							</span>
						よくあるご質問・お問い合わせ</button> */}
							<button onClick={goPolicy} className={`${styles.globalNav_btn} custom_btn`}>
							<span className={styles.globalNav_btn_ar}>
								<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
							</span>
						ご利用規約</button>
							{/* 設定（ScanSDK切替）：本番はenvで固定のため非表示 */}
							{/* ※SDK名と解像度の併記（設定：barkoder + FHD）は一時的に外している */}
							{isScanSdkFixed() ? null : (
								<button onClick={goSetting} className={`${styles.globalNav_btn} custom_btn`}>
								<span className={styles.globalNav_btn_ar}>
									<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
								</span>
							設定{/* ：{scanSdk} + {cameraResolution} */}</button>
							)}
						</nav>
					</div>
					<div className={styles.l_globalNav_bottom}>
						<button className={`${styles.globalNav_closeBtn} custom_btn`} onClick={closeApp}><span>お買い物を中止する</span></button>
						{/* <p className={styles.globalNav_version}>Version 0.00-0</p> */}
					</div>

				</div>
			</div>
		</nav>
		<div className={styles.globalNav_bg} onClick={onMenuBtn}></div>
		</ShoppingStart.Provider>
		</GPSStorelist.Provider>


<AnimatePresence>
	{scanResultFlg && (
		// {setScanResultFlg ? ( // showModalがtrueだったらModal表示
		// if(shoppingPurchaseData){ // showModalがtrueだったらModal表示
		<>
		<motion.div id="addItem" className={stylesB.addItem} style={{ zIndex: 1500 }}
		initial={'initial'}
		animate={'animate'}
		exit={'hidden'}
		variants={scanResultMotionConfig}
		transition={{duration: 0.4, ease: 'easeOut'}}
		>
				<div className={stylesB.addItem_head}>
					<p className={stylesB.addItem_head_txt}>
						<span className={stylesB.addItem_head_check}>
							<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
						</span>
						商品を追加しました
					</p>
				</div>
				<div className={stylesB.addItem_box}>
					<div className={stylesB.addItem_in}>
						<div className={stylesB.addItem_img}>
							{/* <img src="/images/img_item02.png" alt="" width="40" height="40"/> */}
							<img src={shoppingData.data.itemUrl ? shoppingData.data.itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
							{/* <img src={shoppingPurchaseData.data.itemUrl} alt="" width="40" height="40"/> */}
						</div>
						<p className={stylesB.addItem_name}>{shoppingData.data.receiptKanji}</p>
						{/* <p className={styles.addItem_name}>トップバリュ 糖質をおさえたブランデニッシュ 2個入</p> */}
						<div className={stylesB.addItem_priceBox}>
							<p className={stylesB.addItem_price}>
								<span className={`${stylesB.addItem_price_default} ${shoppingData.data.discountSellPrice ? styles.cancel : ''}`}><small>¥</small>
								{
									(() => {
										return (
											(shoppingData.data.sellPrice).toLocaleString('ja-JP')
										)
										// if (shoppingPurchaseData.data.discountSellPrice != null) {
										// 	return shoppingPurchaseData.data.discountSellPrice;
										// } else {
										// 	return shoppingPurchaseData.data.sellPrice;
										// }
									})()
								}
								</span>

								{/* <span className="addItem_price_default cancel"><small>¥</small>198</span> */}
							</p>
						</div>
					</div>
					{
						(() => {
							if (shoppingData.data.discountType === 1) {
								return(
									<div className={stylesB.addItem_discount}>
										<p className={stylesB.addItem_discount_txt}>レジにて<strong>{(shoppingData.data.discountAmount).toLocaleString('ja-JP')}</strong>円引き</p>
										<p className={stylesB.addItem_discount_price}><small>¥</small>{(shoppingData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}else if (shoppingData.data.discountType === 2) {
								return(
									<div className={stylesB.addItem_discount}>
										<p className={stylesB.addItem_discount_txt}>レジにて<strong>{shoppingData.data.discountAmount}</strong>%OFF</p>
										<p className={stylesB.addItem_discount_price}><small>¥</small>{(shoppingData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}else if (shoppingData.data.discountType === 3) {
								return(
									<div className={stylesB.addItem_discount}>
										<p className={stylesB.addItem_discount_txt}>レジにて</p>
										<p className={stylesB.addItem_discount_price}><small>¥</small>{(shoppingData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}
						})()
					}
					{/* <div className="addItem_discount">
						<p className="addItem_discount_txt">レジにて<strong>30</strong>%OFF</p>
						<p className="addItem_discount_price"><small>¥</small>138</p>
					</div> */}

				</div>
		</motion.div>

		<motion.div className="modalBox_cover" style={{ zIndex: 1400 }}
			initial={'initial'}
			animate={'animate'}
			exit={'hidden'}
			variants={scanResultModalBox_cover}
			transition={{duration: 0.35, ease: 'linear'}}
		></motion.div>
		</>
	)}
</AnimatePresence>

	</>
	)
}

export default App;
